import { List } from '@material-ui/core';
import * as React from 'react';
import VersionGroups from 'src/new/versions/VersionGroups';
import VersionStore from 'src/new/versions/VersionStore';
import SelectedVersions from 'src/versions/SelectedVersions';
import VersionListGroup from './VersionListGroup';

interface Props {
    versions: VersionStore;
    selectedVersions: SelectedVersions;
    onSelectedVersionsChange: (selectedVersions: SelectedVersions) => void;
}

export default class VersionList extends React.Component<Props> {

    private displayGroups = [
        VersionGroups.english,
        VersionGroups.interlinear,
        VersionGroups.hebrewCodices,
        VersionGroups.greekCodices,
        VersionGroups.lxxCodices,
        VersionGroups.correctedCodices,
        VersionGroups.hebrewParsingAndStems,
        VersionGroups.greekParsing,
        VersionGroups.greekStems,
        VersionGroups.lxxParsingAndStems,
        VersionGroups.international
    ];

    public render() {
        return (
            <List disablePadding={true}>
                {this.displayGroups.map((group) =>
                    <VersionListGroup
                        key={group.getId()}
                        group={group}
                        versions={this.props.versions.getVersionGroup(group)}
                        selectedVersions={this.props.selectedVersions}
                        onSelectedVersionsChange={this.props.onSelectedVersionsChange} />
                )}
            </List>
        );
    }
}
